export default "__VITE_ASSET__C$xqgrQW__"